<template>
  <div class="maskContainer" v-if="flag">
    <div class="maskBox">
      <div class="title SourceHanSansCN-Medium">隐私条款</div>
      <el-scrollbar class="el-scrollbar" ref="scrollbarRef" @scroll="handleScrollFn">
        <!-- <div class="content SourceHanSansCN-Regular" v-html="privacyClause"></div> -->
        <el-image :src="privacyClause" fit="contain" class="content" />
      </el-scrollbar>
      <div class="menuBox">
        <div class="m m1" @click="handleReject">不同意</div>
        <div class="m m2" :class="isBottom ? 'm2' : 'm3'" @click="handleOpenMask">
          阅读完成并同意
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { defineEmits, onMounted, ref } from "vue";
import { AdaptationScreen, imgCDN, imgVersion } from "@/common/js/config.default";

const emit = defineEmits(["closeMask"]);

const screenType = ref("pc");

const isBottom = ref(false);

// const privacyClause = ref('斯泰兰蒂斯汽车金融有限公司（“我们”或“斯泰兰蒂斯汽金”）感谢您关注我们的产品和服务。我们非常注重您的个人信息与隐私权，保护您的个人信息是我们重要的目标，同时，我们认为您提供的信息能够帮助我们为您提供更好的产品与服务。因此，我们制定了法律声明及隐私政策（“本政策”）以保护您的个人信息。\n' +
//     '您在访问或使用我们的网站、微信公众号及微信小程序（含个人中心小程序、汽车贷款预审批小程序、泰好贷小程序、OCR小程序等）、移动应用、平台及软件（统称为“服务平台”）所产生的相应个人数据、隐私信息等将根据本政策予以处理，我们保证在处理您的个人信息时仅限于实现我们处理目的的最小范围，不会进行与处理目的无关的个人信息处理。请在访问/使用我们的服务平台前，仔细阅读并了解本政策，当您勾选“同意”后即代表您本人已仔细阅读并同意本政策内容，但您有权随时根据本政策撤回同意。如您不同意以下任何内容，您在使用我们的服务平台时可能会受到一些限制，我们并不强制您使用服务平台。\n' +
//     '适用范围\n' +
//     '本政策适用于斯泰兰蒂斯汽金提供的全部产品和服务，包括我们的服务平台，以及载有该等内容的斯泰兰蒂斯汽金网站、移动应用、平台和软件，以及您申请或使用我们的产品或服务，参加我们的调研或营销活动，通过任何方式与我们进行的沟通等；但是，任何非斯泰兰蒂斯汽金的产品或服务不属于本政策的覆盖范围。如我们与您之间另有书面约定，且与本政策不一致的，则以我们与您的另行约定为准。\n' +
//     '个人信息\n' +
//     '本政策的个人信息是指以电子或者其他方式记录的与已识别或者可识别的自然人有关的各种信息，不包括匿名化处理后的信息。根据我们不同的业务类型，我们可能收集的个人信息的范围主要包括：\n' +
//     '1. 个人身份信息：包括姓名、性别、出生日期、身份证件号码及其有效期、户籍信息、地址、电话号码、电子邮件地址、职业、教育程度、工作经验等；\n' +
//     '2. 个人财产信息：包括个人收入状况、拥有的不动产、动产的状况、负债情况等；\n' +
//     '3. 个人生物识别信息：包括签字、笔记、肖像、指纹、声音、人脸识别信息等；\n' +
//     '4. 个人账户信息：包括账号、开户机构、账户余额等；\n' +
//     '5. 个人征信信息：包括依法成立的征信机构提供的个人信用报告；\n' +
//     '6. 用户画像信息：通过收集、汇聚、分析个人信息，对某特定自然人个人特征等方面做出分析或预测，形成的其个人特征模型；\n' +
//     '7. 其它个人信息：有关政府机构、信息机构、金融机构及其它合法信息提供商提供的驾驶信息、犯罪违法违规记录、移动通信运营商信息、以及融资车辆轨迹信息与登记信息等信息、在与您建立/维持业务或其他关系过程中获取/保存的其他个人信息，如通话内容录音、聊天消息、使用服务的时间、网站/移动应用/平台/软件浏览、使用、点击、操作的日志信息、操作系统版本等。\n' +
//     '我们不会收集任何未成年人的个人信息，除非获得该未成年人监护人的事先同意。我们将根据国家相关法律法规的规定保护未成年人的个人信息。\n' +
//     '个人信息的收集\n' +
//     '通常情况下，您无须提供您的个人信息即可访问我们的服务平台，但为了向您提供服务及提高服务质量的目的，或您需要向我们申请汽车贷款服务或融资租赁服务（统称“融资”）、请求服务（例如金融方案咨询、向我们申请汽车贷款预审批或审批服务、向我们申请融资租赁服务、业务咨询、其他相关汽车金融服务等）、参与调研或营销活动，或以其他方式与我们互动的目的时，我们可能会需要您提供一些个人信息（例如您的姓名，电话，地区等），以便为您提供更好的服务；必要的时候，我们将会验证您所提供信息的真实性。此外，本服务平台还将自动收集您的定位城市信息。\n' +
//     '我们提供的汽车贷款预审批服务需要依赖您的部分信息，您必须提供的内容包括姓名、联系电话、意向购车省份、购车城市和购车车型等基础信息，其他信息您可自主选择向我们提供或允许我们收集。在您进一步申请办理汽车贷款预审批的过程中，经您授权后，我们将基于贷款预审批、身份核实、查询您30日内征信调取情况、业务统计、产品和市场分析、为客户提供服务以及维护和发展客户关系等目的，收集您的其他信息（例如您的身份证件号码、工作及单位情况、个人收入状况、婚姻状况等）。经您同意后，您的姓名、手机号和购车意向可能会转交您的意向经销商或意向城市的某一经销商为您跟踪服务，但在您向经销商展示预审批结果二维码之前，经销商不会知晓除您姓名和手机号之外的其他信息。\n' +
//     '您申请汽车贷款预审批的过程中所提供的个人信息仅为贷款预审批所需的信息，如需获取预审批结果，还需要您授权我们查询您在中国人民银行征信系统的征信记录。温馨提示：如您近期频繁授权查询征信记录，可能会影响您在其他金融机构的贷款审批。您每次授权我们查询征信记录的结果有效期为30天。请您于30天内尽快前往意向经销商处购车及提交贷款申请。若超过30天未能完成贷款申请，后续贷款办理过程中我们可能需要再次查询您的征信记录。\n' +
//     '为汽车贷款预审批需要，我们可能会要求您提供与您关联的共同借款人/担保人的个人信息，包括但不限于个人身份信息、个人财产信息，但上述信息的正式采集及使用仍需获得共同借款人/担保人本人正式授权。\n' +
//     '您可能通过一系列途径向我们提供关于您的信息，如登陆或使用本服务平台，接触到与我们相关的产品服务、优惠申请、调研或公众媒体平台等。我们收集您的个人信息的形式可能包括纸质、电子或其他任何形式。\n' +
//     '我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，除非获得您的明确同意。为提供汽车金融服务之目的，我们可能会将您的个人信息安全地提供给第三方（具体参“个人信息分享”）。我们在此承诺，本服务平台不会要求读取您的手机通讯录内容。\n' +
//     '个人信息的使用\n' +
//     '您在本服务平台相应模块填写结束并完成提交后，提供的全部个人信息均将进入我们的后台系统中，仅我们特定授权人员有权查看，您向本服务平台提供的所有个人资料仅为以下目的使用，包括但不限于：（1）通过您提供的手机号码、微信号等向您提供汽车金融服务和管理、产品调查和推广、营销短信、微信等（包括提供定制化的融资方案、融资产品等）；（2）进行市场调研和客户满意度调查；（3）数据分析；（4）向您提供延伸服务（包括将您的个人数据提供给斯泰兰蒂斯汽金的合作经销商、代理或斯泰兰蒂斯汽金的其它关联公司及合作方以便向您提供服务。对于前述公司、组织和个人，斯泰兰蒂斯汽金会与其签署严格的保密协议，并要求其严格按照本政策处理您的个人信息。）；及（5）用于处理与您和您融资车辆相关的纠纷（包括您所提出的咨询、需求和客户投诉等）。\n' +
//     '我们在收集、使用您的个人信息时，将遵循合法、正当、必要和诚信的原则。在以下情形中涉及的信息收集、使用，我们可能无需征得您的授权同意：\n' +
//     '1. 与我们履行法律法规规定的义务所必需的；\n' +
//     '2. 为订立或者履行您与我们之间的合同所必需，主要包括：签约、办理车辆抵押、还款、逾期催收等；\n' +
//     '3. 与国家安全、国防安全直接相关的；\n' +
//     '4. 与公共安全、公共卫生、重大公共利益直接相关的；\n' +
//     '5. 与刑事侦查、起诉、审判和判决执行等直接相关的；\n' +
//     '6. 出于维护您或其他个人的生命、财产等重大合法权益但又无法及时向您告知并得到您同意的，但是我们会在紧急情况消除后及时向您告知；\n' +
//     '7. 依照相关法律在合理的范围内处理您自行公开或者其他已经合法公开的个人信息；\n' +
//     '8. 从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；\n' +
//     '9. 用于维护所提供的产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；\n' +
//     '10. 法律法规规定的其他情形。\n' +
//     '个人信息的存储及保留期限\n' +
//     '我们将采取符合国家标准的安全措施和技术手段存储和保护您的个人信息，以防止其丢失、被误用、受到未授权访问或泄漏、被篡改或毁坏。您的个人信息将存储于中华人民共和国境内，如我们需要跨境传输您的个人信息，我们将会单独征得您的授权同意。除非您要求我们删除您的个人信息，我们将根据国家法律、法规的规定确定您个人信息的存储期限，以满足您不时的产品或服务需求。\n' +
//     '在我们尽力对您的个人数据加以保密的同时，我们不能保证该等数据不会由于计算机黑客攻击、计算机病毒侵入、硬件设施损坏、或因政府行为、司法强制要求等而可能被披露、泄露、丢失、被盗用或被篡改等，而您同意我们对此将不承担任何责任。\n' +
//     '为了向您提供所要求的服务及产品之需，我们将保留所向您收集的信息。我们将根据法律法规或其他监管政策的要求在向您提供服务的期间以及我们与您之间业务关系结束后的合理必要期间内存储和处理您的个人信息。超出前述存储期限后，我们将尽力对您的个人信息进行删除或匿名化处理，若删除从技术上难以实现的，将仅对各项信息进行存储和采取必要的安全保护措施。\n' +
//     '个人信息的分享\n' +
//     '为贷前审批、各方履行合同及我们商业推广所需，我们可能将所获得及收集的信息在下述情况下进行共享或与第三方分享，具体第三方包括与您融资车辆相关的经销商、汽车厂商及其他第三方机构（其他第三方机构明细参“第三方机构目录”）：\n' +
//     '1. 因法律法规或政策规定，如因传票、政府讯问、诉讼、争议解决或类似法律程序所需；\n' +
//     '2. 当我们善意地相信相关披露对保护我们的权利、保护您的安全或其他人的安全、对调查欺诈行为或者应对法律执行的要求是必需的；\n' +
//     '3. 单独或与斯泰兰蒂斯汽金关联企业共同向相关政府机构披露信息以便符合法律、法规、政府或行政命令；');

const privacyClause = ref(
  imgCDN + "assets/aboutUs/loanAppointment/privacy-pc.png?v=" + imgVersion
);
const flag = ref(false);

const handleOpenMask = () => {
  if (isBottom.value) {
    closeMask();
    emit("isAgree", true);
  }
};

const handleReject = () => {
  closeMask();
  emit("isAgree", false);
};

const openMask = () => {
  flag.value = true;
};

const closeMask = () => {
  flag.value = false;
};

const scrollbarRef = ref(null);

const handleScrollFn = (e) => {
  let scrollContainer = scrollbarRef.value.wrap$; // Element UI 使用 wrap$ 作为滚动容器的引用
  if (
    scrollContainer.scrollHeight -
      (scrollContainer.scrollTop + scrollContainer.clientHeight) <
    10
  ) {
    // 滚动到底部
    isBottom.value = true;
  } else {
    //isBottom.value = false;
  }
};

defineExpose({
  openMask,
  closeMask,
});

onMounted(() => {
  AdaptationScreen(
    () => {
      //console.log("手机")
      screenType.value = "mobile";
    },
    () => {
      //console.log("PC")
      screenType.value = "pc";
    }
  );
});
</script>

<style scoped lang="scss">
@import "@/common/scss/breakpoints";

.maskContainer {
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;

  .maskBox {
    width: 1200px;
    height: 800px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    overflow: hidden;

    .title {
      width: 100%;
      font-size: 32px;
      color: #000;
      margin-top: 60px;
      letter-spacing: 2px;
      text-align: center;
    }

    .el-scrollbar {
      width: 950px;
      height: 500px;
      margin: 30px auto 0;

      .content {
        width: 940px;
        height: auto;
        font-size: 20px;
        line-height: 2;
      }
    }

    .menuBox {
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 60px;

      .m {
        width: 190px;
        height: 60px;
        border-radius: 5px;
        font-size: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        &.m1 {
          background: #e6e6e6;
          color: #999999;
        }

        &.m2 {
          background: #004393;
          color: #fff;
          margin-left: 125px;
        }

        &.m3 {
          background: rgba(#243782, 0.5);
          color: #fff;
          margin-left: 125px;
        }
      }
    }
  }
}

@include media-breakpoint-up("md") {
  @import "./index-md.scss";
}
</style>
